var _path, _style, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityLicenseTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 28,
    viewBox: "0 0 169 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0057 0H169V28H21.0057L0 13.5L21.0057 0Z",
    fill: "#3B8AC3"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    text {\n      letter-spacing: 0.75px; \n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "55%",
    y: "55%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "white",
    fontSize: 14,
    fontFamily: "Arial, sans-serif"
  }, "University License")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityLicenseTag);
export default __webpack_public_path__ + "static/media/universityLicenseTag.39eb5b74912cadfcfed013e9ac47b459.svg";
export { ForwardRef as ReactComponent };